<div class="page-content">
  <!-- Header Section -->
  <div class="page-title-container">
    <div class="breadcrumb-spacer"></div>
    <h1 class="page-title">Offices</h1>
  </div>

  <div class="offices-container">
    <!-- Filters Section -->
    <mat-card class="filters-card">
      <mat-card-content>
        <form [formGroup]="searchForm" class="filters-form">
          <div class="filter-row">
            <!-- Search Field -->
            <mat-form-field appearance="outline" class="search-field">
              <mat-label>Search offices</mat-label>
              <input
                matInput
                [(ngModel)]="searchQuery"
                [ngModelOptions]="{ standalone: true }"
                placeholder="Search by code or name..."
                autocomplete="off"
                (input)="onSearchInput()"
              />
              <mat-icon
                matSuffix
                [style.cursor]="searchQuery ? 'pointer' : 'default'"
                (click)="clearSearch()"
                >{{ searchQuery ? "close" : "search" }}</mat-icon
              >
            </mat-form-field>
            <button
              mat-stroked-button
              class="reset-filters-btn"
              type="button"
              (click)="clearSearch()"
              [disabled]="!searchQuery"
            >
              <mat-icon>replay</mat-icon>
              Reset
            </button>
          </div>
        </form>
      </mat-card-content>
    </mat-card>

    <!-- Loading State -->
    @if (isLoading) {
      <div class="loading-container">
        <mat-spinner diameter="40"></mat-spinner>
        <span>Loading offices...</span>
      </div>
    }

    <!-- Error State -->
    @if (error && !isLoading) {
      <app-error-state
        [message]="error"
        (retry)="loadOffices()"
      ></app-error-state>
    }

    <!-- Offices Table -->
    @if (!isLoading && !error) {
      <mat-card class="table-card no-padding">
        <mat-card-content>
          <div class="table-container">
            <table
              mat-table
              [dataSource]="dataSource"
              matSort
              [matSortActive]="sortField"
              [matSortDirection]="sortDirection"
              (matSortChange)="sortOffices($event)"
              class="offices-mat-table"
            >
              <!-- Code Column -->
              <ng-container matColumnDef="code">
                <th
                  mat-header-cell
                  *matHeaderCellDef
                  mat-sort-header="code"
                  class="code-column"
                >
                  Code
                </th>
                <td mat-cell *matCellDef="let office" class="code-column">
                  <a
                    class="cell-link"
                    [routerLink]="['/admin/offices', office.code]"
                  >
                    {{ office.code }}
                  </a>
                </td>
              </ng-container>

              <!-- Letter Code Column -->
              <ng-container matColumnDef="letterCode">
                <th
                  mat-header-cell
                  *matHeaderCellDef
                  mat-sort-header="letterCode"
                  class="letter-code-column"
                >
                  Location Code
                </th>
                <td mat-cell *matCellDef="let office" class="letter-code-column">
                  {{ office.letterCode ?? '-' }}
                </td>
              </ng-container>

              <!-- Description Column -->
              <ng-container matColumnDef="description">
                <th
                  mat-header-cell
                  *matHeaderCellDef
                  mat-sort-header="description"
                >
                  Name
                </th>
                <td
                  mat-cell
                  *matCellDef="let office"
                  class="office-description"
                >
                  {{ office.description }}
                </td>
              </ng-container>

              <!-- Country Column -->
              <ng-container matColumnDef="country">
                <th
                  mat-header-cell
                  *matHeaderCellDef
                  mat-sort-header="country"
                  class="country-column"
                >
                  Country
                </th>
                <td mat-cell *matCellDef="let office" class="country-column">
                  {{ office.country ?? '-' }}
                </td>
              </ng-container>

              <!-- Status Column -->
              <ng-container matColumnDef="status">
                <th
                  mat-header-cell
                  *matHeaderCellDef
                  class="status-column"
                >
                  Status
                </th>
                <td mat-cell *matCellDef="let office" class="status-column">
                  <span
                    class="badge"
                    [ngClass]="office.active ? 'badge-active' : 'badge-inactive'"
                  >
                    {{ office.active ? 'Active' : 'Inactive' }}
                  </span>
                </td>
              </ng-container>

              <!-- Resource Count Column -->
              <ng-container matColumnDef="resourceCount">
                <th
                  mat-header-cell
                  *matHeaderCellDef
                  mat-sort-header="resourceCount"
                  class="resource-count-column"
                >
                  Resources
                </th>
                <td mat-cell *matCellDef="let office" class="resource-count-column">
                  {{ office.resourceCount }}
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr
                mat-row
                *matRowDef="let row; columns: displayedColumns"
              ></tr>

              <!-- Empty State -->
              <tr class="mat-row" *matNoDataRow>
                <td
                  class="mat-cell no-data-cell"
                  [attr.colspan]="displayedColumns.length"
                >
                  <div class="empty-state">
                    <mat-icon>search_off</mat-icon>
                    <span>No offices found matching your search</span>
                  </div>
                </td>
              </tr>
            </table>
          </div>

          <mat-paginator
            [length]="totalCount"
            [pageSize]="pageSize"
            [pageIndex]="pageIndex"
            [pageSizeOptions]="pageSizeOptions"
            (page)="onPageChange($event)"
            showFirstLastButtons
          >
          </mat-paginator>
        </mat-card-content>
      </mat-card>
    }
  </div>
</div>
